import type { CollectionKind } from "~/utils/collectionKind"

export const routeBaseFor = (kind: CollectionKind): string =>
  kind === "noos" ? "/demand/noos/$collectionId" : "/demand/fashion/$collectionId"

/**
 * A collection tab other tabs open filtered: write its filters at `routeId` (the key its route's
 * `FilterScopeProvider` pins), then navigate to `to`.
 */
export const demandTab = (kind: CollectionKind, tab: "variants" | "demand") => ({
  to: `/demand/${kind}/$collectionId/${tab}` as const,
  routeId: `/_auth/demand/${kind}/$collectionId/_layout/${tab}` as const,
})

export type DemandTabRouteId = ReturnType<typeof demandTab>["routeId"]
